import React from 'react';
import CaseForm from '../components/CaseForm';


const ActionCreatePage = () => {
  return (<CaseForm />);
};

export default ActionCreatePage;
